import UserService from '@/services/UserService'
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
import VueAxios from 'vue-axios'
var hash = require('object-hash')

class EfishDataObject {
  constructor () {
    // ensure registered in vue
    Vue.use(VueAxios, axios)
    const self = this
    this.name = 'efishdatacache'
    this.purgeTimeout = setTimeout(function () {
      self.purgeOldData()
    }, 100)
    // if cache object does not exist, create
    if (this.getCache() == null) {
      this.clearAll()
    }
  }

  clearAll () {
    localStorage.setItem(this.name, JSON.stringify({
      data: {},
      keys: [],
      expires: [],
      created: []
    }))
  }

  getCache () {
    return JSON.parse(localStorage.getItem(this.name))
  }

  setData (name, data, expires) {
    const cache = this.getCache()
    cache.data[name] = data
    cache.keys.push(name)
    cache.expires.push(expires)
    cache.created.push(Date.now())
    localStorage.setItem(this.name, JSON.stringify(cache))
  }

  getData (url, params = null, method = 'get', expires = null) {
    const dataKey = this.buildKey(url, params, method)
    const cache = this.getCache()
    if (cache !== null && typeof cache.data[dataKey] !== 'undefined') {
      const now = new Date()
      const expiration = new Date(cache.expires[cache.keys.indexOf(dataKey)])
      if (expiration < now || expires === -1 /* forced refresh */) {
        // expired, purge and return false;
        this.purgeData(dataKey)
        return this.sendDataRequest(url, params, method, expires)
      } else {
        return cache.data[dataKey]
      }
    } else {
      return this.sendDataRequest(url, params, method, expires)
    }
  }

  async sendDataRequest (url, params, method, expires) {
    const dataKey = this.buildKey(url, params, method)
    const header = await UserService.authHeader()
    if (header === false) {
      // invalid token or other auth problem.
      return Promise.reject(new Error('Invalid auth'))
    }
    const config = {
      url: UserService.baseUrl() + url,
      method: method,
      headers: header
    }
    if (method === 'get' && params !== null) {
      config.params = params
    } else if (method === 'post' && params !== null) {
      config.data = params
    }
    return Vue.axios(config)
      .then((response) => {
        this.setData(dataKey, response.data, moment(expires).toDate().getTime())
        return response.data
      }, err => {
        throw err
      })
  }

  purgeData (key) {
    const cache = this.getCache()
    const index = cache.keys.indexOf(key)
    delete cache.data[key]
    cache.keys.splice(index, 1)
    cache.expires.splice(index, 1)
    cache.created.splice(index, 1)
    localStorage.setItem(this.name, JSON.stringify(cache))
  }

  purgeOldData () {
    // TODO: create purge logic
  }

  buildKey (url, params, method) {
    return hash({ url: url, params: params, method: method })
  }
}

const EfishData = new EfishDataObject()
export default EfishData
